module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu/btn_link-318617fd4510cb634d79d12f5aaca93b.png";